import React from "react";
import NavHeightAdjust from "../../components/navbar/NavHeightAdjust";
import Profile from "./Profile";

const ProfilePage = () => {
  return (
    <NavHeightAdjust>
      <Profile />
    </NavHeightAdjust>
  );
};

export default ProfilePage;
